// Up to two initials from a display name, ignoring a trailing "(me)"/"(eu)".
export function initials(name: string) {
  return (
    name
      .replace(/\s+\((?:me|eu)\)$/i, "")
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0])
      .join("")
      .toUpperCase() || "?"
  );
}
